<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">符号</span>
        </div>
        <form action="">
          <div class="popup-content">
            <p class="txt mb20">一つ選択してください。</p>
            <div class="qa-content">
              <div class="qa-content-block">
                <div class="qa-content-block-title">民事事件記録符号</div>
                <div class="qa-content-block-title-sub">簡易裁判所</div>
                <ul class="qa-content-block-list">
                  <li class="qa-content-block-item">
                    <div class="formparts radio">
                      <input type="radio" name="qa_search_sign_01" id="qa_search_sign_01_01">
                      <label for="qa_search_sign_01_01">イ 和解事件</label>
                    </div>
                  </li>
                  <li class="qa-content-block-item">
                    <div class="formparts radio">
                      <input type="radio" name="qa_search_sign_01" id="qa_search_sign_01_02">
                      <label for="qa_search_sign_01_02">ロ 和解事件</label>
                    </div>
                  </li>
                  <li class="qa-content-block-item">
                    <div class="formparts radio">
                      <input type="radio" name="qa_search_sign_01" id="qa_search_sign_01_03">
                      <label for="qa_search_sign_01_03">ハ 和解事件</label>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="qa-content-block">
                <div class="qa-content-block-title">民事事件記録符号</div>
                <div class="qa-content-block-title-sub">簡易裁判所</div>
                <ul class="qa-content-block-list">
                  <li class="qa-content-block-item">
                    <div class="formparts radio">
                      <input type="radio" name="qa_search_sign_02" id="qa_search_sign_02_01">
                      <label for="qa_search_sign_02_01">イ 和解事件</label>
                    </div>
                  </li>
                </ul>
                <div class="qa-content-block-title-sub">最高裁判所</div>
                <ul class="qa-content-block-list">
                  <li class="qa-content-block-item">
                    <div class="formparts radio">
                      <input type="radio" name="qa_search_sign_02" id="qa_search_sign_02_02">
                      <label for="qa_search_sign_02_02">イ 和解事件</label>
                    </div>
                  </li>
                  <li class="qa-content-block-item">
                    <div class="formparts radio">
                      <input type="radio" name="qa_search_sign_02" id="qa_search_sign_02_03">
                      <label for="qa_search_sign_02_03">イ 和解事件</label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="button mt32">
              <button class="btn" type="submit" name="QA_display_settings">決定</button>
            </div>      
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({

  setup (props, context) {

    const group1 = reactive({
    })
    const close = () => {
      context.emit('closeSearchSign')
    }
   
    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  .button .btn {
    width: 232px;
    margin-right: auto;
    margin-left: auto;
  }
  .qa-content {
    border: 1px solid $color-line;
    border-radius: 8px;
    overflow: hidden;
    &-block {
      &-title {
        background-color: $color-hdg;
        color: #fff;
        font-weight: bold;
        font-size: 2.0rem;
        padding: 20px 24px;
      }
      &-title-sub {
        background-color: $color-bg-form;
        color: $color-hdg;
        font-weight: bold;
        font-size: 1.6rem;
        padding: 22px 24px;
      }
      &-list {
        list-style: none;
      }
      &-item {
        padding: 16px 20px;
        .formparts {
          margin-bottom: 0;
        }
        & + .qa-content-block-item {
          border-top: 1px solid $color-line;
        }
      }
    }
  }
}
</style>
